import { WIDEN_DEFAULT_OPENGRAPH_IMAGE_HEIGHT, WIDEN_DEFAULT_OPENGRAPH_IMAGE_WIDTH } from '@hub/libs/constants';
import { WidenUtil } from '@hub/libs/widen-utils';
import { WidenImageConfig } from '@hub/models/widen-image-config';
import { useMemo } from 'react';

export type OpenGraphImage = {
  url: string;
  alt: string;
};

export type OpenGraphData = {
  type: 'website';
  url: string;
  images?: OpenGraphImage[];
};

export const usePreparedOpenGraphData = (baseUrl: string, categoryName: string, productImage: string | null) =>
  useMemo(() => {
    let data: OpenGraphData = {
      type: 'website',
      url: baseUrl,
    };

    if (productImage) {
      const widenKey = WidenUtil.extractWidenImageId(productImage);
      const widenName = WidenUtil.extractWidenImageName(productImage);

      const imageSrc = WidenUtil.generateWidenImageUrl(
        new WidenImageConfig(
          widenKey,
          widenName,
          WIDEN_DEFAULT_OPENGRAPH_IMAGE_WIDTH,
          WIDEN_DEFAULT_OPENGRAPH_IMAGE_HEIGHT
        )
      );
      const image: OpenGraphImage = {
        url: imageSrc,
        alt: categoryName,
      };

      data = Object.assign(data, {
        images: [image],
      });
    }

    return data;
  }, [productImage, categoryName, baseUrl]);
